import React from 'react';

const DropDownToggle = ({ id = 1, label = null, checked = false, onChange = null }) => {
  return (
    <div className="toggle-with-label">
      {!!label && <span className="toggle-label">{label}</span>}
      <div className="toggle-switch">
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={onChange}
          className="toggle-switch-checkbox"
        />
        <label className="toggle-switch-label" htmlFor={id}>
          <span className="toggle-switch-inner" />
          <span className="toggle-switch-switch" />
        </label>
      </div>
    </div>
  );
};

export default DropDownToggle;
